import { Box, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If, Else } from "lib/@components/switch"
import { legislationHref } from "routes/schedule/lib/legislation-href.mjs"
import { LegislationDetailField } from "./legislation-detail-field"

export function LegislationDetailView({ legislation }) {
    const redirectUrl = legislation?.redirectUrl ?? ""
    const url = legislation?.url ?? ""
    const redirectHref = redirectUrl || null
    const href = url ? legislationHref(url) : null

    return (
        <Stack spacing={3} data-cy="legislation-detail-view">
            <LegislationDetailField label="NAME">
                <Typography variant="body1" data-cy="legislation-detail-name">
                    {legislation?.title}
                </Typography>
            </LegislationDetailField>

            <LegislationDetailField label="SFG20 URL">
                <Box data-cy="legislation-detail-redirect">
                    <If truthy={redirectHref}>
                        <Box
                            component="a"
                            href={redirectHref}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-cy="legislation-detail-redirect-link"
                            sx={LINK_SX}
                        >
                            <span>{redirectUrl}</span>
                            <Iconify icon="mdi:open-in-new" sx={ICON_SX} />
                        </Box>
                    </If>
                </Box>
            </LegislationDetailField>

            <LegislationDetailField label="DESTINATION URL">
                <Box data-cy="legislation-detail-url">
                    <If truthy={href}>
                        <Box
                            component="a"
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-cy="legislation-detail-url-link"
                            sx={LINK_SX}
                        >
                            <span>{url}</span>
                            <Iconify icon="mdi:open-in-new" sx={ICON_SX} />
                        </Box>
                        <Else>
                            <Typography variant="body2" sx={{ color: "text.secondary" }}>
                                Could not find the destination URL for this legislation.
                            </Typography>
                        </Else>
                    </If>
                </Box>
            </LegislationDetailField>

            <If truthy={legislation?.description}>
                <LegislationDetailField label="DESCRIPTION">
                    <Typography
                        variant="body1"
                        sx={{ whiteSpace: "pre-wrap" }}
                        data-cy="legislation-detail-description"
                    >
                        {legislation?.description}
                    </Typography>
                </LegislationDetailField>
            </If>
        </Stack>
    )
}

const LINK_SX = {
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    color: "primary.main",
    textDecoration: "none",
    fontWeight: 600,
    wordBreak: "break-all",
    "&:hover": { textDecoration: "underline" },
}

const ICON_SX = { width: 18, height: 18, flexShrink: 0 }
